export default "skymp5-front/7196aafda52490d0047f8325763363bb.gif";